/**
 * Routes of area (e) — finance. OWNED BY area (e) — finance: tighten `validateSearch`, add loaders, swap `component`
 * for the real screen (keep the paths — boards.ts hrefs point at them). Generated by the foundation.
 */
import { createRoute } from "@tanstack/react-router";
import { boardsAt } from "@/boards/board-switch";
import { z } from "zod";
import { guard, staffRoute } from "@/app/route-base";

/** Finance screens keep no state in the URL (filters, windows and tabs are page state, as on the boards). */
const NoSearch = z.object({});
const noSearch = (s: Record<string, unknown>) => NoSearch.parse(s);

/** AF-Vue */
export const financeRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/finance",
  validateSearch: noSearch,
  beforeLoad: guard("finance", "read"),
  component: boardsAt("/finance"),
});

/** AF-Paiements */
export const financePaiementsRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/finance/paiements",
  validateSearch: noSearch,
  beforeLoad: guard("finance", "read"),
  component: boardsAt("/finance/paiements"),
});

/** AF-Bloques */
export const financePaiementsBloquesRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/finance/paiements/bloques",
  validateSearch: noSearch,
  beforeLoad: guard("finance", "read"),
  component: boardsAt("/finance/paiements/bloques"),
});

/** AF-Remboursements */
export const financeRemboursementsRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/finance/remboursements",
  validateSearch: noSearch,
  beforeLoad: guard("finance", "read"),
  component: boardsAt("/finance/remboursements"),
});

/** AF-Dossier-Paiement */
export const financePaiementsDossieridRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/finance/paiements/$dossierId",
  validateSearch: noSearch,
  beforeLoad: guard("finance", "read"),
  component: boardsAt("/finance/paiements/$dossierId"),
});

/** AF-Remboursements-AE */
export const financeRemboursementsAutoEntrepreneursRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/finance/remboursements/auto-entrepreneurs",
  validateSearch: noSearch,
  beforeLoad: guard("finance", "read"),
  component: boardsAt("/finance/remboursements/auto-entrepreneurs"),
});

/** AF-Rapprochement */
export const financeRapprochementRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/finance/rapprochement",
  validateSearch: noSearch,
  beforeLoad: guard("finance", "read"),
  component: boardsAt("/finance/rapprochement"),
});

/** AF-Abonnements */
export const financeAbonnementsRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/finance/abonnements",
  validateSearch: noSearch,
  beforeLoad: guard("finance.admin", "read"),
  component: boardsAt("/finance/abonnements"),
});

/** AF-Compta-Mensuelle */
export const financeComptaMensuelleRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/finance/compta-mensuelle",
  validateSearch: noSearch,
  beforeLoad: guard("finance.admin", "read"),
  component: boardsAt("/finance/compta-mensuelle"),
});

/** AF-Grilles */
export const financeGrillesRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/finance/grilles",
  validateSearch: noSearch,
  beforeLoad: guard("finance.admin", "read"),
  component: boardsAt("/finance/grilles"),
});

/** AF-Compte-Client */
export const financeComptesCompanyidRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/finance/comptes/$companyId",
  validateSearch: noSearch,
  beforeLoad: guard("finance.admin", "read"),
  component: boardsAt("/finance/comptes/$companyId"),
});

/** AF-Saas-Factures */
export const financeFacturesRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/finance/factures",
  validateSearch: noSearch,
  beforeLoad: guard("finance", "read"),
  component: boardsAt("/finance/factures"),
});

/** AF-Facturation-Cabinets */
export const financeFacturationCabinetsRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/finance/facturation-cabinets",
  validateSearch: noSearch,
  beforeLoad: guard("finance", "read"),
  component: boardsAt("/finance/facturation-cabinets"),
});

export const financeRoutes = [financeRoute, financePaiementsRoute, financePaiementsBloquesRoute, financeRemboursementsRoute, financePaiementsDossieridRoute, financeRemboursementsAutoEntrepreneursRoute, financeRapprochementRoute, financeAbonnementsRoute, financeComptaMensuelleRoute, financeGrillesRoute, financeComptesCompanyidRoute, financeFacturesRoute, financeFacturationCabinetsRoute] as const;
